package com.partejar.app.core.session

interface SessionLocalStateCleaner {
    fun clear()
}

class DefaultSessionLocalStateCleaner(
    private val tokenStore: SessionTokenStore,
    private val currentWorkspaceRepository: CurrentWorkspaceRepository,
    private val biometricPreferences: BiometricPreferences
) : SessionLocalStateCleaner {
    override fun clear() {
        tokenStore.clear()
        currentWorkspaceRepository.clear()
        biometricPreferences.clear()
    }
}
